module.exports = __webpack_public_path__ + "static/lecture-alexa-2062e801976ba911582ad31d742e8b61.jpg";